import React from 'react';
import { compose } from 'recompose';
import config from '../../config';
import { TransLink } from '../Common/Translations';
import { withStoreDetail } from '../Common/Providers/WithStoreDetail';
import { willHideOnMuslimPro } from '../Common/Store/Store';
import { withResizeHelper } from '../Common/ResizeHelper';

const s3Path = `${config.s3BucketUrl}/pages/landing`;

const AWorldOfOptionsCards = ({ img, text, url }) => (
  <TransLink url={url}>
    <div className="card">
      <div className="card-img-top mosaic-categoryBox bg-gray-lighten-4 lazyload" data-bg={`${s3Path}${img}`}>
      </div>
      <div className="card-body px-0">
        <h5 className="card-text text-primary ProximaNova-Bold h6">{text}</h5>
      </div>
    </div>
  </TransLink>
);

const PhotobookPassBanner = (props) => {
  const { t, breakpoint } = props;
  const isSmallScreen = breakpoint === 'xs' || breakpoint === 'sm';
  const bannerImage = isSmallScreen
    ? t('landing_page.photobookpass_banner_mobile', '/2020/home_img_1212x590.png')
    : t('landing_page.photobookpass_banner_desktop', '/2020/home_img_1230x150.png');
  return (
    <div id="pbpass_banner" className="container my-5">
      <div className="row text-center">
        <div className="col">
          <TransLink url={t('landing_page.photobookpass_link', '/pass')}>
            <img className="img-fluid bg-gray-lighten-4 lazyload" data-src={`${s3Path}${bannerImage}`} width="1230" height="150" alt="Photobook Pass Banner"/>
          </TransLink>
        </div>
      </div>
    </div>
  );
};

const PhotobookAppBanner = (props) => {
  const { t, breakpoint } = props;
  const isSmallScreen = breakpoint === 'xs' || breakpoint === 'sm';
  const bannerImage = isSmallScreen
    ? t('landing_page.photobookapp_banner_mobile', '/2020/home_img_1212x590.png')
    : t('landing_page.photobookapp_banner_desktop', '/2020/home_img_1230x150.png');
  return (
    <div id="pbapp_banner" className="container my-5">
      <div className="row text-center">
        <div className="col">
          <a href={t('landing_page.photobookapp_link', 'https://photobook.onelink.me/QDvH/ca575a3f')} target="_blank">
            <img className="img-fluid bg-gray-lighten-4" src={`${s3Path}${bannerImage}`} alt="Photobook App Banner"/>
          </a>
        </div>
      </div>
    </div>
  );
}

const MosaicAndLongBanner = (props) => {
  const {
    store,
    t,
  } = props;
  return (
    <div className="my-5">
      <div className="container content-visibility-auto">
        <div className="row d-flex justify-content-center text-center">
          <div className="col-lg-8">
            <h2 className="ProximaNova-Bold landing-h4 mb-2">{t('landing_page.mosaic_title', 'Discover A World Of Possibilities')}</h2>
            <p className="text-gray">{t('landing_page.mosaic_description', 'Dive into our spectrum of lifestyle offerings and personalisation services, designed to turn your moments and gifts into lifetime treasures.')}</p>
          </div>
        </div>
      </div>
      <div id="mosaic" className="container mb-5 content-visibility-auto">
        <div className="row px-2 text-center">
          <div className="col-md-6 mb-3 px-2">
            <AWorldOfOptionsCards text={t('landing_page.mosaic_card_text_1', '')}
                                  url={t('landing_page.mosaic_card_link_1', '/')}
                                  img={t('landing_page.mosaic_card_image_1', '')}/>
          </div>
          <div className="col-md-6 mb-3 px-2">
            <AWorldOfOptionsCards text={t('landing_page.mosaic_card_text_2', '')}
                                  url={t('landing_page.mosaic_card_link_2', '/')}
                                  img={t('landing_page.mosaic_card_image_2', '')}/>
          </div>
          <div className="col-md-4 mb-3 px-2">
            <AWorldOfOptionsCards text={t('landing_page.mosaic_card_text_3', '')}
                                  url={t('landing_page.mosaic_card_link_3', '/')}
                                  img={t('landing_page.mosaic_card_image_3', '')}/>
          </div>
          <div className="col-md-4 mb-3 px-2">
            <AWorldOfOptionsCards text={t('landing_page.mosaic_card_text_4', '')}
                                  url={t('landing_page.mosaic_card_link_4', '/')}
                                  img={t('landing_page.mosaic_card_image_4', '')}/>
          </div>
          <div className="col-md-4 mb-3 px-2">
            <AWorldOfOptionsCards text={t('landing_page.mosaic_card_text_5', '')}
                                  url={t('landing_page.mosaic_card_link_5', '/')}
                                  img={t('landing_page.mosaic_card_image_5', '')}/>
          </div>
        </div>
      </div>

      {store.has_active_subscriptions &&
        <PhotobookPassBanner {...props}/>
      }
      {!store.has_active_subscriptions &&
        <PhotobookAppBanner {...props}/>
      }

    </div>
  );
};

const enhance = compose(
  withStoreDetail,
  willHideOnMuslimPro,
  withResizeHelper,
);
export default enhance(MosaicAndLongBanner);
export const undecorated = MosaicAndLongBanner;



// WEBPACK FOOTER //
// ./src/LandingPage/MosaicAndLongBanner.js